import * as React from 'react';

import i18n from 'helper/i18n';

import config from 'helper/mapBackendConfig';

type OverlayTemplateProps = {
	closable?: boolean;
	animation?: string;
	contentStyle?: string;
	closeButton?: boolean;
};

const OverlayTemplate = ({ closable = false, animation, contentStyle, closeButton = false }: OverlayTemplateProps) => {
	const ariaLabelClose: string = i18n('react.impulsCoach.components.overlay.ariaLabelCloseButton');
	let wrapProps: any = {
		className: `lity-wrap${contentStyle ? ` lity-wrap--${contentStyle}` : ''}`,
		role: 'document',
	};

	if (closable) {
		wrapProps = { ...wrapProps, 'data-lity-close': 'true' };
	}

	return (
		<div className="js-m-overlay__template lity-hide">
			<div
				className={`lity${animation ? ` lity--${animation}` : ''}`}
				role="dialog"
				aria-label={i18n('react.impulsCoach.components.overlay.ariaLabelCloseDialog')}
				tabIndex={-1}
			>
				<div {...wrapProps}>
					<div className="lity-loader" aria-hidden="true">
						...
					</div>
					<div className="lity-container">
						<div className="lity-content" />
						{closeButton && (
							<div className="lity-close-button">
								<button
									className="a-knob a-knob--filled-green-light a-knob--s"
									aria-label={ariaLabelClose}
									data-lity-close={(!!closable).toString()}
								>
									<img
										src={`${config.env.baseUrlUi}/assets/img/svg/close.svg`}
										alt={ariaLabelClose}
									/>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

OverlayTemplate.displayName = 'Overlay(Template)';

export default OverlayTemplate;
